import {doc} from '../docs.js';
import { float, utils, extract} from './utils.js';
import {lazy} from './lazy.js';
import {extractCode} from './extract.js';

doc(
    "gl.unpack",
    {
        "vec2/vec3/vec4": ""
    },
    "Unpacks a vector into its components, out of its outlets",
    () => 4,
    {
        inlets: 1
    });

export const gl_unpack = (object) => {
    object.needsHotReload = true;
    let lazyReturn = undefined;
    return ([msg]) => {
        let {uniforms, functions, variables, closure} = msg;
        let codes = extractCode(msg);

        let base = {
            uniforms, variables, closure, functions
        };
        return [
            {... base, code: `(${float(codes[0])}.r)`},
            {... base, code: `(${float(codes[0])}.g)`},
            {... base, code: `(${float(codes[0])}.b)`},
            {... base, code: `(${float(codes[0])}.a)`},
        ];
    };
};
 
